import { FormattedMessage } from "react-intl";
import { pollManagement } from "./pollManagement";
import { social } from "./social";
import * as yup from "yup";

export const createPoll = {
  label: <FormattedMessage id="P_CREATE_A_POLL" />,
  path: (tenantName) => `${pollManagement.path(tenantName)}/createPoll`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Social Connect",
      path: `${social.path(tenantName)}`,
      onClick: () => navigate(`${social.path(tenantName)}`),
    },
    {
      key: 2,
      label: pollManagement.label,
      path: `${pollManagement.path(tenantName)}`,
      onClick: () => navigate(`${pollManagement.path(tenantName)}`),
    },
    {
      key: 3,
      label: createPoll.label,
      path: `${createPoll.path(tenantName)}`,
      onClick: () => navigate(`${createPoll.path(tenantName)}`),
    },
  ],
};

export const pollSchema = yup.object().shape({
  pollQuestion: yup.string(),
  pollDescription: yup.string(),
  option1: yup.string(),
  option2: yup.string(),
  option3: yup.string(),
  option4: yup.string(),
  optionList: yup.array(),
  isFeedbackMessageEnabled: yup.boolean(),
  isLearnerFeedbackEnabled: yup.boolean(),
  learnerFeedbackPlaceholder: yup.string().max(25),
});
